const usePermissionConfig = () => {
  return {};
};

export default usePermissionConfig;
